export default __webpack_public_path__ + "static/media/img-3.0f9ce878.jpg";